import React from 'react';
import { observer } from 'mobx-react';
import { Button } from '@blueprintjs/core';
import { omitAriaProps } from 'core/form/components/util/omitFieldProps';

const ConfigureDataViewButton = ({ dataview, loading, ...rest }) => (
  <Button
    disabled={loading}
    text="Configure"
    onClick={dataview.showConfigureDialog}
    className="pt-small pt-medium"
    icon="cog"
    {...omitAriaProps(rest)}
  />
);

export default observer(ConfigureDataViewButton);
